"use client";

import { c as _c } from "react/compiler-runtime";
import { CornerRibbon, ImageWell, SHOP_CATALOG_CARD_HEIGHT_CLASS_NAME, SHOP_SQUARE_CATALOG_CARD_HEIGHT_CLASS_NAME } from "../components/catalog-card-primitives";
import { ParcelTileArtwork } from "../components/parcel-corner";
import ShopCardDecoration from "../components/shop-card-decoration";
import React from "react";
import { FiArrowRight, FiPackage } from "react-icons/fi";
import QuantityStepper from "@/components/ui/quantity-stepper";
import { useCatalogImageLayout } from "@/contexts/catalog-image-layout-provider";
import { formatCurrency } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { ShopItem } from "@/types/shop";
import { packagePricingSummary } from "./pricing";
export const PackageTile: React.FC<{
  item: ShopItem;
  onSelect?: () => void;
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
}> = t0 => {
  const $ = _c(102);
  const {
    item,
    onSelect,
    quantity,
    onQuantityChange
  } = t0;
  const {
    catalogImageLayout
  } = useCatalogImageLayout();
  let T0;
  let interactive;
  let savings;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== catalogImageLayout || $[1] !== item || $[2] !== onQuantityChange || $[3] !== onSelect || $[4] !== quantity) {
    const {
      price,
      savings: t13
    } = packagePricingSummary(item);
    savings = t13;
    let Root;
    let hasImage;
    let hasIncludes;
    let hasQuantityControl;
    let rootProps;
    let t14;
    let usesSquareImage;
    let usesSquareLayout;
    if ($[20] !== catalogImageLayout || $[21] !== item.imageUrl || $[22] !== item.packageIncludedItems || $[23] !== onQuantityChange || $[24] !== onSelect || $[25] !== quantity) {
      const includedItems = item.packageIncludedItems ?? [];
      hasImage = Boolean(item.imageUrl);
      usesSquareLayout = catalogImageLayout === "SQUARE";
      usesSquareImage = usesSquareLayout && hasImage;
      hasIncludes = includedItems.length > 0;
      const maxIncludedRows = usesSquareImage ? 2 : hasImage ? 1 : 4;
      const visibleIncludedCount = includedItems.length > maxIncludedRows ? maxIncludedRows - 1 : maxIncludedRows;
      const remainingIncludedCount = Math.max(0, includedItems.length - visibleIncludedCount);
      interactive = Boolean(onSelect);
      hasQuantityControl = quantity !== undefined && Boolean(onQuantityChange);
      Root = interactive && !hasQuantityControl ? "button" : "div";
      let t15;
      if ($[35] !== hasQuantityControl || $[36] !== interactive || $[37] !== onSelect) {
        t15 = interactive && !hasQuantityControl ? {
          type: "button" as const,
          onClick: onSelect
        } : {};
        $[35] = hasQuantityControl;
        $[36] = interactive;
        $[37] = onSelect;
        $[38] = t15;
      } else {
        t15 = $[38];
      }
      rootProps = t15;
      t14 = hasIncludes ? <div className="space-y-1"><p className="text-micro font-semibold uppercase tracking-[0.2em] text-primary/70">Includes</p><ul className="space-y-0.5 text-caption leading-5 text-foreground-secondary">{includedItems.slice(0, visibleIncludedCount).map(_temp)}{remainingIncludedCount > 0 && <li className="text-primary">{visibleIncludedCount > 0 ? `+${remainingIncludedCount} more` : `${remainingIncludedCount} included items`}</li>}</ul></div> : null;
      $[20] = catalogImageLayout;
      $[21] = item.imageUrl;
      $[22] = item.packageIncludedItems;
      $[23] = onQuantityChange;
      $[24] = onSelect;
      $[25] = quantity;
      $[26] = Root;
      $[27] = hasImage;
      $[28] = hasIncludes;
      $[29] = hasQuantityControl;
      $[30] = interactive;
      $[31] = rootProps;
      $[32] = t14;
      $[33] = usesSquareImage;
      $[34] = usesSquareLayout;
    } else {
      Root = $[26];
      hasImage = $[27];
      hasIncludes = $[28];
      hasQuantityControl = $[29];
      interactive = $[30];
      rootProps = $[31];
      t14 = $[32];
      usesSquareImage = $[33];
      usesSquareLayout = $[34];
    }
    const includesList = t14;
    T0 = Root;
    t8 = rootProps;
    const t15 = usesSquareLayout ? SHOP_SQUARE_CATALOG_CARD_HEIGHT_CLASS_NAME : SHOP_CATALOG_CARD_HEIGHT_CLASS_NAME;
    const t16 = interactive && "cursor-pointer hover:-translate-y-0.5 hover:shadow-[0_8px_28px_-4px_rgb(0_0_0_/_0.25),0_18px_48px_-12px_rgb(0_0_0_/_0.35)] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background";
    if ($[39] !== t15 || $[40] !== t16) {
      t9 = cx("group relative flex min-h-[230px] w-full flex-col overflow-hidden rounded-2xl text-left", t15, "bg-background shadow-[0_2px_8px_-2px_rgb(0_0_0_/_0.15),0_10px_24px_-12px_rgb(0_0_0_/_0.25)] ring-1 ring-black/5", "transition-[transform,box-shadow,border-color] duration-500 ease-out", t16);
      $[39] = t15;
      $[40] = t16;
      $[41] = t9;
    } else {
      t9 = $[41];
    }
    if ($[42] !== hasQuantityControl || $[43] !== interactive || $[44] !== item.name || $[45] !== onSelect) {
      t10 = interactive && hasQuantityControl && <button type="button" aria-label={`View ${item.name}`} aria-haspopup="dialog" className="absolute inset-0 z-10 rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background" onClick={onSelect} />;
      $[42] = hasQuantityControl;
      $[43] = interactive;
      $[44] = item.name;
      $[45] = onSelect;
      $[46] = t10;
    } else {
      t10 = $[46];
    }
    let t17;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <ParcelTileArtwork />;
      $[47] = t17;
    } else {
      t17 = $[47];
    }
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <ShopCardDecoration frame="tile" tone="package" artwork={t17} corner={<CornerRibbon><FiPackage className="h-5 w-5" /></CornerRibbon>} />;
      $[48] = t11;
    } else {
      t11 = $[48];
    }
    if ($[49] !== item) {
      t12 = <ImageWell item={item} />;
      $[49] = item;
      $[50] = t12;
    } else {
      t12 = $[50];
    }
    t5 = "relative flex min-h-0 flex-1 flex-col p-5 pt-0";
    if ($[51] !== item.category) {
      t6 = <div className="flex min-h-6 items-start justify-between gap-3">{item.category ? <p className="font-semibold uppercase text-primary/70 text-micro tracking-[0.24em]">{item.category}</p> : <span aria-hidden={true} />}</div>;
      $[51] = item.category;
      $[52] = t6;
    } else {
      t6 = $[52];
    }
    const t18 = hasImage && hasIncludes && !usesSquareImage ? "line-clamp-1" : "line-clamp-2";
    let t19;
    if ($[53] !== t18) {
      t19 = cx("font-serif text-[1.9rem] font-medium leading-[1.08] tracking-tight text-foreground transition-colors group-hover:text-primary", t18);
      $[53] = t18;
      $[54] = t19;
    } else {
      t19 = $[54];
    }
    let t20;
    if ($[55] !== item.name || $[56] !== t19) {
      t20 = <h3 className={t19} title={item.name}>{item.name}</h3>;
      $[55] = item.name;
      $[56] = t19;
      $[57] = t20;
    } else {
      t20 = $[57];
    }
    let t21;
    if ($[58] !== hasImage || $[59] !== hasIncludes || $[60] !== item.description || $[61] !== usesSquareImage) {
      t21 = item.description && <p className={cx("max-w-[90%] whitespace-pre-line text-caption leading-5 text-foreground-secondary", hasImage && hasIncludes && !usesSquareImage ? "mt-2" : "mt-3", usesSquareImage && hasIncludes ? "line-clamp-2 sm:line-clamp-1" : usesSquareImage ? "line-clamp-3 sm:line-clamp-2" : hasImage && hasIncludes ? "line-clamp-1" : hasImage ? "line-clamp-2" : "line-clamp-5")} title={item.description}>{item.description}</p>;
      $[58] = hasImage;
      $[59] = hasIncludes;
      $[60] = item.description;
      $[61] = usesSquareImage;
      $[62] = t21;
    } else {
      t21 = $[62];
    }
    let t22;
    if ($[63] !== hasImage || $[64] !== hasIncludes || $[65] !== includesList || $[66] !== usesSquareImage) {
      t22 = includesList && <div className={cx("max-w-[90%]", hasImage && hasIncludes && !usesSquareImage ? "mt-2" : "mt-3")}>{includesList}</div>;
      $[63] = hasImage;
      $[64] = hasIncludes;
      $[65] = includesList;
      $[66] = usesSquareImage;
      $[67] = t22;
    } else {
      t22 = $[67];
    }
    if ($[68] !== t20 || $[69] !== t21 || $[70] !== t22) {
      t7 = <div className="min-h-0 flex-1 overflow-hidden">{t20}{t21}{t22}</div>;
      $[68] = t20;
      $[69] = t21;
      $[70] = t22;
      $[71] = t7;
    } else {
      t7 = $[71];
    }
    t4 = "flex shrink-0 flex-wrap items-end justify-between gap-x-4 gap-y-2 border-t border-primary/10 pt-4";
    t3 = "min-w-0";
    t1 = "block font-serif text-2xl font-medium leading-none tracking-tight text-foreground tabular-nums";
    t2 = formatCurrency(price);
    $[0] = catalogImageLayout;
    $[1] = item;
    $[2] = onQuantityChange;
    $[3] = onSelect;
    $[4] = quantity;
    $[5] = T0;
    $[6] = interactive;
    $[7] = savings;
    $[8] = t1;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[5];
    interactive = $[6];
    savings = $[7];
    t1 = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t13;
  if ($[72] !== t1 || $[73] !== t2) {
    t13 = <span className={t1}>{t2}</span>;
    $[72] = t1;
    $[73] = t2;
    $[74] = t13;
  } else {
    t13 = $[74];
  }
  let t14;
  if ($[75] !== savings) {
    t14 = savings > 0 && <p className="text-caption font-semibold text-primary">you save {formatCurrency(savings)}</p>;
    $[75] = savings;
    $[76] = t14;
  } else {
    t14 = $[76];
  }
  let t15;
  if ($[77] !== t13 || $[78] !== t14 || $[79] !== t3) {
    t15 = <div className={t3}>{t13}{t14}</div>;
    $[77] = t13;
    $[78] = t14;
    $[79] = t3;
    $[80] = t15;
  } else {
    t15 = $[80];
  }
  let t16;
  if ($[81] !== interactive || $[82] !== onQuantityChange || $[83] !== quantity) {
    t16 = quantity !== undefined && onQuantityChange ? <div className="relative z-20 ml-auto" onClick={_temp2}><QuantityStepper value={quantity} onChange={onQuantityChange} className="bg-background/90" /></div> : interactive && <span className="pointer-events-none ml-auto inline-flex items-center gap-1.5 pb-1 text-caption font-semibold text-primary">Select<FiArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></span>;
    $[81] = interactive;
    $[82] = onQuantityChange;
    $[83] = quantity;
    $[84] = t16;
  } else {
    t16 = $[84];
  }
  let t17;
  if ($[85] !== t15 || $[86] !== t16 || $[87] !== t4) {
    t17 = <div className={t4}>{t15}{t16}</div>;
    $[85] = t15;
    $[86] = t16;
    $[87] = t4;
    $[88] = t17;
  } else {
    t17 = $[88];
  }
  let t18;
  if ($[89] !== t17 || $[90] !== t5 || $[91] !== t6 || $[92] !== t7) {
    t18 = <div className={t5}>{t6}{t7}{t17}</div>;
    $[89] = t17;
    $[90] = t5;
    $[91] = t6;
    $[92] = t7;
    $[93] = t18;
  } else {
    t18 = $[93];
  }
  let t19;
  if ($[94] !== T0 || $[95] !== t10 || $[96] !== t11 || $[97] !== t12 || $[98] !== t18 || $[99] !== t8 || $[100] !== t9) {
    t19 = <T0 {...t8} className={t9}>{t10}{t11}{t12}{t18}</T0>;
    $[94] = T0;
    $[95] = t10;
    $[96] = t11;
    $[97] = t12;
    $[98] = t18;
    $[99] = t8;
    $[100] = t9;
    $[101] = t19;
  } else {
    t19 = $[101];
  }
  return t19;
};
function _temp(includedItem, index) {
  return <li key={includedItem.itemId ?? `${includedItem.name}-${index}`} className="truncate">{includedItem.quantity}× {includedItem.name}</li>;
}
function _temp2(event) {
  return event.stopPropagation();
}